import React from "react";
import { withRouter, Route, Switch } from "react-router-dom";

import { humanizeNumber } from "../../../../lib/utils/numberFunctions";
import { truncate } from "../../../../lib/utils/stringFunctions";

import Tickets from "../containers/Tickets";
import RegistrationForm from "../containers/RegistrationForm";
import EventHeader from "../components/EventHeader";

export class EventRegisterForm extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      selected_tickets: this.getInitalTicketLevels(props),
      tickets: this.getInitialTickets(props),
      showDesc: true,
      cardExpiration: props.event_register_form.card_expiration,
    };

    this.updateCardExpiration = this.updateCardExpiration.bind(this);
    this.updateTicketState = this.updateTicketState.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleTransition = this.handleTransition.bind(this);
    this.handleRemoveTicket = this.handleRemoveTicket.bind(this);
  }

  componentDidMount() {
    const {
      event_register_form: { errors },
    } = this.props;

    if (errors && Object.keys(errors).length > 0) {
      this.handleTransition("form");
    }
  }

  getInitalTicketLevels(props) {
    const { tickets } = props.event_register_form;

    if (tickets && tickets.length > 0) {
      return tickets.map((ticket) => ticket.ticket_level_id);
    }
    return [];
  }

  getInitialTickets(props) {
    const {
      event_register_form: { tickets },
    } = props;

    if (tickets) {
      return tickets.reduce((obj, ticket) => {
        obj[ticket.ticket_level_id] = ticket;
        return obj;
      }, {});
    } else {
      return {};
    }
  }

  updateCardExpiration(e) {
    const val = e.target.value.replace(/\D/g, "");
    if (val.length > 2) {
      const newVal = val.match(/.{1,2}/g).slice(0, 2);
      this.setState({ cardExpiration: newVal.join("/") });
    } else {
      this.setState({ cardExpiration: val });
    }
  }

  updateTicketState(ticketId, number) {
    const ticket = Object.assign({}, this.state.tickets[ticketId]);

    ticket.number = number;

    const tickets = Object.assign({}, this.state.tickets);
    tickets[ticketId] = ticket;

    this.setState({
      tickets,
    });
  }

  handleClick(ticket_level) {
    const ticket = {
      ticket_level_id: ticket_level._id.$oid,
      amount: ticket_level.amount || 0,
      number: 1,
      category: ticket_level.category,
      name: ticket_level.name,
    };
    const tickets = Object.assign({}, this.state.tickets);

    if (!tickets.hasOwnProperty(ticket.ticket_level_id)) {
      tickets[ticket.ticket_level_id] = ticket;
      let selectedTickets = this.state.selected_tickets.slice();

      selectedTickets.push(ticket.ticket_level_id);

      this.setState({
        selected_tickets: selectedTickets,
        tickets: tickets,
      });
    }
  }

  handleRemoveTicket(ticket) {
    const { selected_tickets, tickets } = this.state;

    const updatedSelectedTickets = selected_tickets.filter(
      (selected) => selected !== ticket,
    );
    const updatedTickets = Object.assign({}, tickets);

    delete updatedTickets[ticket];

    this.setState({
      selected_tickets: updatedSelectedTickets,
      tickets: updatedTickets,
    });
  }

  handleTransition(route) {
    const {
      history,
      match: { params },
    } = this.props;

    history.push(`/events/${params.event_id}/${route}`);
  }

  injectProps(Component) {
    return (
      <Component
        handleClick={this.handleClick}
        updateTicketState={this.updateTicketState}
        updateCardExpiration={this.updateCardExpiration}
        handleTransition={this.handleTransition}
        updateState={this.updateState}
        handleRemoveTicket={this.handleRemoveTicket}
        {...this.props}
        {...this.state}
      />
    );
  }

  render() {
    const { showDesc } = this.state;
    const { event } = this.props;

    return (
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <EventHeader event={event} showDesc={showDesc} />
          </div>
        </div>

        <Route
          exact
          path="/events/:event_id/tickets"
          render={() => this.injectProps(Tickets)}
        />
        <Route
          exact
          path="/events/:event_id/form"
          render={() => this.injectProps(RegistrationForm)}
        />
      </div>
    );
  }
}

export default withRouter(EventRegisterForm);
